module.exports = __webpack_public_path__ + "static/media/box-heart.138a6d5b.svg";